import { createContext, useContext, useEffect, useState } from "react";
import { checkOnlineStatus } from "../helpers/checkOnlineStatus";

export const IsOnlineContext = createContext<{
    isOnline: boolean;
}>({
    isOnline: true
});

export const IsOnlineContextProvider = ({ children }: React.PropsWithChildren) => {
  
  const [isOnline, setIsOnline] = useState<boolean>(true);

  useEffect(() => {
    const update = async () => {
      const online = await checkOnlineStatus();
      setIsOnline(online)
    }

    update()

    const interval = setInterval(update, 10000);

    return () => {
      clearInterval(interval);
    };
  }, []);
  
  return <IsOnlineContext.Provider value={{
    isOnline
  }}>
    {children}
  </IsOnlineContext.Provider>
}

export const useIsOnlineContext = (): { isOnline : boolean } => {
  return useContext(IsOnlineContext)
}
